import { Component,  OnInit, OnDestroy, ViewChild, EventEmitter } from '@angular/core';
import { BasePageComponent } from '../../base-page';
import { IPageData } from 'src/app/interfaces/page-data';
import { Spinkit } from 'ng-http-loader';
import { Subject } from 'rxjs';
import { IAppState } from 'src/app/interfaces/app-state';
import { Router, ActivatedRoute } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { HttpService } from 'src/app/services/http/http.service';
import { Store } from '@ngrx/store';
import * as PageActions from '../../../store/actions/page.actions';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { IOption } from 'src/app/ui/interfaces/option';
import swal from 'sweetalert2'
import { element } from 'protractor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-tasteprofile',
  templateUrl: './edit-tasteprofile.component.html',
  styleUrls: ['./edit-tasteprofile.component.scss']
})
export class EditTasteprofileComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  clickmydetail: boolean = false
  clickfood: boolean = false
  editDetails: boolean = true
  myfriends :boolean = false
  sharefriends :boolean = false
  fileData: File = null;
  User_details
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  messageFilesize: string;
  imageFile: any;
  currentAvatar
  errorMessage;
  defalutimage ='./assets/img/PngItem_1503945.png'
  up_fname
  up_lname
  up_gender
  feet
  up_inch
  email
  is_facebook
  is_google
  up_phone
  up_address
  up_profile_image
  user_preferences = []
  user_preference_spice
  user_ingredients = []
  allAllergens = []
  alldietary = []
  algns = []
  dietPref = []
  ingredients_arry = []
  spicevalue = [];
  ingredientbind = []
  userDislikes = []
  userDislikesbind = []
  userDietary = []
  userAllergens = []
  dietaryarry = []
  allergensarry = []
  backtolocation = '0'
  referalcode: any;
  listoffriends =[];
  shareID 
  
  message = "click to select";
  load:boolean = false;

  data = [
    { "label": "Man", "value": "Man" },
    { "label": "Woman", "value": "Woman" },
    { "label": "Non-Binary", "value": "Non-Binary" },
    { "label": "Don't wish to disclose", "value": "Don't wish to disclose" }
  ]
  datas = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" }
  ]
  datafeet = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" },
    { "label": "5", "value": "5" },
    { "label": "6", "value": "6" },
    { "label": "7", "value": "7" },
    { "label": "8", "value": "8" }
  ]

  datainch = [
    { "label": "1", "value": "1" },
    { "label": "2", "value": "2" },
    { "label": "3", "value": "3" },
    { "label": "4", "value": "4" },
    { "label": "5", "value": "5" },
    { "label": "6", "value": "6" },
    { "label": "7", "value": "7" },
    { "label": "8", "value": "8" },
    { "label": "9", "value": "9" },
    { "label": "10", "value": "10" },
    { "label": "11", "value": "11" },
    { "label": "12", "value": "12" },
  ]


  userIngredients
  Baselinkshare: any;
  taste_code: any;
  sharewithfriends: string;
  myfriend: string;
  mydetails: string;
  preferences: string;
  closeDropdown: EventEmitter<boolean>;


  constructor(store: Store<IAppState>,
    public httpSv: HttpService, private router: Router,
    private route: ActivatedRoute, private _bottomSheet: MatBottomSheet) {
    super(store, httpSv);
    this.closeDropdown = new EventEmitter<boolean>();
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route: 'editprofile'
        }
      ]
    };
  }


  ngOnInit() {
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.shareID = sessionStorage.getItem('sharefriend');
    this.mydetails = sessionStorage.getItem('Details');
    this.myfriend = sessionStorage.getItem('myfriend');
    this.sharewithfriends = sessionStorage.getItem('sharefriends')
    this.preferences = sessionStorage.getItem('preferences');
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    this.httpSv.shareCodeGet().subscribe(res=>{
      if(res['status'] == true){
        this.referalcode = btoa(res['result'].data)
        this.Baselinkshare= environment.sharelinkUrldecode + this.referalcode 
    
      }
    },(err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
            
    })
    if (this.UserCondition) {
      this.getfoodPreferences();
      this.userProfileDetails();
      this.getIngredients();
      // this.getallAllergens();
      this.getallDiestpref();
      this.friends();
      this.shareCodeGet();
      this.tasteDetailsget();
      this.allAllergens.forEach(element => {
        this.algns.push(element.allergens_id)
      });

      this.alldietary.forEach(element => {
        this.dietPref.push(element.diet_preference_id)
      });
      this.user_ingredients.forEach(element => {
        this.ingredients_arry.push(element.sub_ingredient_id)
      })

    }
 if(this.shareID){
   sessionStorage.removeItem('sharefriend')
 }


 if(this.mydetails){
  this.onclickmydetail();
}
else if(this.preferences){
this.onclickfood();
}
else if(this.myfriend){
this.onclickMyfriends();
}
else if(this.sharewithfriends){
this.onclickShare();
}



  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }



  
  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }

  
   
  
  onclickmydetail() {
    this.clickmydetail = true
    this.editDetails = false
    this.myfriends = false
    this.sharefriends  = false
    this.backtolocation = '1'
  }

  onclickfood() {
    this.clickfood = true
    this.editDetails = false
    this.myfriends = false
    this.sharefriends = false
    this.backtolocation = '1'
  }
  onclickMyfriends(){
    this.myfriends = true
    this.sharefriends = false
    this.clickmydetail = false
    this.editDetails = false
    this.backtolocation = '1'
  }

  onclickShare(){
    this.sharefriends = true
    this.shareID = true
   this.myfriends = false
   this.clickmydetail = false
   this.editDetails = false
   this.backtolocation = '1'
  }


  fileChange(event) {
    let fileList: FileList = event.target.files;
  }

  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round((fsize / 1024));
      if (fileSize < 2048) {
        this.imageFile = new FormData();
        this.imageFile.append('file', event.target.files[0]);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize = ""
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
        reader.readAsDataURL(file);
        this.uploadImage();
      }
      else {
        this.messageFilesize = "File too Big, please select a file less than 2mb"
      }
    }

  }
  uploadImage() {
    this.httpSv.updateuserImage(this.imageFile).subscribe(
      response => {
        if (response['status'] == true) {
     
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
        }
        else if (err.status == 500) {
          this.logout();
        }
      }
    )
  }

  userProfileDetails() {
    this.httpSv.userProfileDetails().subscribe(res => {
      if (res['status'] == true) {
        this.User_details = res['result']
        this.up_fname = res['result'].up_fname
        this.up_lname = res['result'].up_lname
        this.up_gender = res['result'].up_gender
        this.feet = res['result'].feet
        this.up_inch = res['result'].up_inch
        this.email = res['result'].email
        this.is_facebook = res['result'].is_facebook 
        this.is_google = res['result'].is_google
        this.up_phone = res['result'].up_phone
        this.up_address = res['result'].up_address
        this.currentAvatar = res['result'].up_profile_image
      }
    },(err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }          
    })
  }

  updateProfile(up_fname, up_lname, up_phone, up_gender, up_address, feet, up_inch) {
    this.httpSv.updateUserProfile(up_fname, up_lname, up_phone, up_gender, up_address, feet, up_inch).subscribe(
      response => {
        if (response['status'] == true) {
        }
      },
      (err: HttpErrorResponse) => {

        this.errorMessage = err.error.message;

        Swal.fire({
          title: this.errorMessage
        }
        );
        if (err.status == 422) {
          this.errorMessage = err.error.message.fname ? err.error.message.fname : "";  
          Swal.fire({
            title: this.errorMessage
          }
          );
        }
        if (err.status == 401) {
          this.logout();

        }
        else if (err.status == 500) {
          this.logout();
        }
      }
    )
  }

  getfoodPreferences() {
    this.httpSv.getfoodPreferences().subscribe(
      res => {
        if (res['status'] == true) {
          this.user_preferences = res['result']
          this.user_preference_spice = res['result'].user_preference_spice
          this.userIngredients = res['result'].userIngredients
          this.userDislikes = res['result'].userDislikes
          this.userDietary = res['result'].userDietary
          this.userAllergens = res['result'].userAllergens
          if (this.userAllergens) {
            this.userAllergens.forEach(element => {
              this.allergensarry.push(element.allergens_id)
            });
          }
          else {
            this.allergensarry = []
          }
          if (this.userDietary) {
            this.userDietary.forEach(element => {
              this.dietaryarry.push(element.diet_preference_id)
            });
          }
          else {
            this.userDietary = []
          }
          if (this.userIngredients) {
            this.userIngredients.forEach(element => {
              this.ingredientbind.push(element.sub_ingredient_id)
            });
          }
          else {
            this.userIngredients = []
          }
          if (this.userDislikes) {
            this.userDislikes.forEach(element => {
              this.userDislikesbind.push(element.sub_ingredient_id)
            });
          }
          else {
            this.userDislikes = []
          }
          this.load = true;
        }
      },(err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        this.load = true;

				if (err.status == 401) {
					this.logout();
				}
				else if (err.status == 500) {
					this.logout();
				}
              
			}
    )
  }
  getIngredients() {
    this.httpSv.getIngredients().subscribe(
      res => {
        if (res['status'] == true) {
          this.user_ingredients = res['result']
        }
      },(err: HttpErrorResponse) => {
				this.errorMessage = err.error.message;
				if (err.status == 401) {
					this.logout();
				}
				else if (err.status == 500) {
					this.logout();
				}         
			}
    )
  }

  getallDiestpref() {
    this.httpSv.getallDiestpref().subscribe(
      res => {
        if (res['status'] == true) {
          this.alldietary = res['result'].data
        }
      }, (err: HttpErrorResponse) => {
				this.errorMessage = err.error.message;
				if (err.status == 401) {
					this.logout();
				}
				else if (err.status == 500) {
					this.logout();
				}
              
			}
    )
  }
  // getallAllergens() {
  //   this.httpSv.getallAllergens().subscribe(
  //     res => {
  //       if (res['status'] == true) {
  //         this.allAllergens = res['result'].data
  //       }
  //     }, (err: HttpErrorResponse) => {
	// 			this.errorMessage = err.error.message;
	// 			if (err.status == 401) {
	// 				this.logout();
	// 			}
	// 			else if (err.status == 500) {
	// 				this.logout();
	// 			}
              
	// 		}
  //   )
  // }

  UpdatefoodPreferences(allergensarry, dietPref, ingredientbind, user_preference_spice, userDislikesbind) {
    this.httpSv.foodPreferences(allergensarry, dietPref, ingredientbind, user_preference_spice, userDislikesbind).subscribe(
      res => {
        if (res['status'] == true) {
        }
      },(err: HttpErrorResponse) => {
				this.errorMessage = err.error.message;
				if (err.status == 401) {
					this.logout();
				}
				else if (err.status == 500) {
					this.logout();
				}
              
			}
    )
  }
  onclickmyorders(){
    this.router.navigate(['horizontal/order-list'])
  }
  backtodetails() {
    this.editDetails = true
    this.clickfood = false
    this.clickmydetail = false
    this.router.navigate(['/horizontal/userprofile'])
    sessionStorage.removeItem("Details")
    sessionStorage.removeItem("myfriend")
    sessionStorage.removeItem("sharefriends")
    sessionStorage.removeItem("preferences")
    // location.reload();
  }



  friends(){
    this.httpSv.friends().subscribe(res =>{
      if (res['status'] == true){
        this.listoffriends = res['result']
      }
    },(err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
            
    })
  }
 
  shareCodeGet(){
    this.httpSv.shareCodeGet().subscribe(res=>{
      if(res['status'] == true){
        this.referalcode = btoa(res['result'].data)
      }
    },(err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
            
    })
  }
  onCloseDropdown() {
    this.closeDropdown.emit(true);
  }
  onclickFb(){
    window.open( environment.sharelinkUrlFb + this.referalcode );
  }
  onclickwhatapp(){
    window.open( environment.sharelinkUrlwhatapp + this.referalcode );
  }
  onclickTwitter(){
    window.open( environment.sharelinkUrltwitter + this.referalcode )
  }


  tasteDetailsget(){
    this.httpSv.tasteDetailsget().subscribe(res=>{
      if(res['status'] == true){
        this.taste_code = res['result'].data.tc_code
      }
    }, (err: HttpErrorResponse) => {
     if (err.status == 401) {
       this.logout();
     }
     else if (err.status == 500) {
       this.logout();
     }
   })
     }
     ondeletefriend(id){
      this.onCloseDropdown();
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          this.httpSv.deletefriends(id).subscribe(res =>{
            if(res['status'] == true ){
              this.ngOnInit();
              // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              //   this.router.navigate(['horizontal/edit-tasteprofile']);
              //  }); 
            }
          })
        }
      });
     
    }

}
